import React from "react";
import Template1 from './template_gift/Template1';
import { api_url } from '../config';
import '../css/gifttemplate.css';
import 'font-awesome/css/font-awesome.min.css';
import cookie from 'react-cookies';

class Giftpage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			giftdet: '',
			lang: {},
			template_id: '',
			res_status: '',
			coupon_id: ''
		}


	}
	/* iframeResize() {
	var body = document.body;
    var html = document.documentElement;

	 var height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );
					   
	window.parent.postMessage("resize::"+height,"*");
	} */

	componentDidMount() {
		
		const gift_id = this.props.match.params.gift_id;
		this.props.updateRetarget(gift_id, 'gift');

		let visitCookiegift = cookie.load('visitCookiegift_' + gift_id);
		if (visitCookiegift === '' || typeof visitCookiegift === 'undefined') {
			this.CookieSet('visitCookiegift_' + gift_id, 1, 'visitCookiegift', 24);
			visitCookiegift = 1;
		} else {
			visitCookiegift = '';
		}


		const postdata = new FormData();
		postdata.append("gift_id", gift_id);
		postdata.append("visitcookiegift", visitCookiegift);
		fetch(api_url + "/api/fetchgiftdet", {
			method: "POST",
			body: postdata
		})
			.then(res => res.json())
			.then(
				(result) => {
					
					if (result.status === 200) {

						this.setState({
							giftdet: result,
							template_id: result.template_id,
							gift_id: gift_id,
							res_status: result.status,
							lang: JSON.parse(result.language)

						});
						//localStorage.setItem('mrk', 1);
					} else {

						this.setState({
							res_status: result.status,
							lang: JSON.parse(result.language)
						});
						

					}
					if(result.body_bg_color !== ''){
						document.body.style.backgroundColor = result.body_bg_color;
					}	


				},

				(error) => {
					this.setState({

					});
				}
			)
			//setInterval(this.iframeResize(), 1000);
			
	}
	CookieSet(cookiename, cookievalue, action, exp) {

		const expires = new Date();
		const exp1 = 1000 * 60 * 60 * exp;
		const maxAge = 60 * 60 * exp;
		expires.setDate(Date.now() + exp1);
		cookie.save(cookiename, cookievalue, { path: '/', expires, maxAge: maxAge });


	}



	render() {
		const styleg = this.state.giftdet;
		const styletmp = {
			bg_box: {
				backgroundImage: "url(" + styleg.gift_image + ")"
			},
			top_bg_col2: {

				backgroundColor: styleg.top_bg_col2
			},
			top_bg_col1: {

				backgroundColor: styleg.top_bg_col1
			},
			top_bg_col199: {
				backgroundColor: styleg.top_bg_col1 + '66'
			},
			top_text_col: {
				color: styleg.top_text_col
			},
			mid_bg_col: {
				/* backgroundColor: styleg.mid_bg_col + "66" */
				backgroundColor: styleg.mid_bg_col
			},
			mid_text_col: {
				color: styleg.mid_text_col
			},
			mid_btn: {
				backgroundColor: styleg.mid_btn_bg_col,
				color: styleg.mid_btn_text_col,
				border: '1px solid ' + styleg.mid_btn_text_col
			},
			mid_btn_bg: {
				backgroundColor: styleg.mid_btn_bg_col,
				color: styleg.mid_btn_text_col,

			},
			mid_btn_txt_col: {

				color: styleg.mid_btn_text_col

			},
			bot_bg_col: {
				backgroundColor: styleg.bot_bg_col
			},
			bot_text_col: {
				color: styleg.bot_text_col
			},
			bot_btn: {
				backgroundColor: styleg.bot_btn_bg_col,
				color: styleg.bot_btn_text_col,
				border: '1px solid ' + styleg.bot_btn_text_col
			},
			br_top_bot_100: {
				borderTop: '140px solid ' + styleg.top_bg_col1,
				borderBottom: '137px solid ' + styleg.top_bg_col1
			},
			br_left_8: {
				borderLeft: '8px solid ' + styleg.top_bg_col1
			},
			br_top_170: {
				borderTop: '170px solid ' + styleg.top_bg_col1
			},
			br_top_275: {
				borderTop: '275px solid ' + styleg.top_bg_col1
			}
		};


		return (
			<div>
				{(this.state.res_status === 200) ? (
					<div>
						{
							(this.state.template_id === 1) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div style={styletmp.mid_bg_col} className="div-gift-template-one mid_bg_col">
												<div style={styletmp.bg_box} className="div-gift-template m_bot5">
													<div style={styletmp.top_bg_col1} className="div-template-header top_bg_col1">
														<img id="gift_logo" src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>

													<div style={styletmp.top_bg_col2} className="div-template-footer top_bg_col2">
														<span style={styletmp.top_text_col} className="top_text_col">{this.state.giftdet.name}</span>
													</div>
												</div>
												<div className="col-md-12 bb">
													<div className="div-footer-description">
														<p style={styletmp.mid_text_col} className="mid_text_col">{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 2) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-two div-template-gift-check br15px">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div style={styletmp.top_bg_col1} class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 3) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-three div-template-gift-check br15px">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="triangle-right" style={styletmp.br_top_bot_100}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 4) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-four">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pl0">
															<div class="triangle-right" style={styletmp.br_left_8}></div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 5) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-five">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
															<div class="half-circle" style={styletmp.top_bg_col1}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 6) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-six">
												<div class="div-gift-template m_bot5" style={styletmp.top_bg_col1}>
													<div class="div-template-child">
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 7) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer" style={styletmp.top_bg_col1}>
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 8) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0 pl0" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 9) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-nine">
												<div class="div-gift-template m_bot5">
													<div class="div-template-child" style={styletmp.top_bg_col1}>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 10) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-ten">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer" style={styletmp.top_bg_col1}>
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 11) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eleven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left" style={styletmp.br_top_275}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 12) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twelve">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
															<div class="div-logo" style={styletmp.top_bg_col1}>
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="div-right" style={styletmp.br_top_170}></div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 13) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-child" style={styletmp.top_bg_col199}>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 14) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pt10" style={styletmp.top_bg_col1}>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
															<div class="div-points">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 15) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fifteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-8 col-md-8 col-sm-8 col-8">
															<div class="div-left" style={styletmp.br_top_275}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 16) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0" style={styletmp.top_bg_col1}>
															<div class="div-points">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 17) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventeen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8" style={styletmp.top_bg_col1}>
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<p style={styletmp.top_text_col}>{this.state.giftdet.name}</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 18) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pt10">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<p style={styletmp.top_text_col}>{this.state.giftdet.name}</p>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 19) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-ninteen">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0 pl0" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 20) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twenty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-parent" style={styletmp.top_bg_col1}>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 21) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-parent bg_col1">
														<div class="div-logo" style={styletmp.top_bg_col1}>
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header" style={styletmp.top_bg_col1}>
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 22) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0 pl0" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 23) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-circle" style={styletmp.top_bg_col1}>
													</div>
													<div class="div-logo">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-card-header">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 24) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left" style={styletmp.br_top_275}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 25) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentyfive">
												<div class="div-gift-template m_bot5 bg_box" style={styletmp.bg_box}>
													<div class="div-template-footer" style={styletmp.top_bg_col1}>
														<div class="row">
															<div class="col-md-6">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
															<div class="col-md-6 text-right">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 26) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentysix">
												<div class="div-gift-template m_bot5 bg_box" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0">
															<div class="triangle-right" style={styletmp.br_top_bot_100}></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 27) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
															<div class="triangle-right"></div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>

													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 28) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-4 col-md-4 col-sm-4 col-4 pr0" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-1 col-md-1 col-sm-1 col-1 pl0">
															<div class="triangle-left"></div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 29) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-twentynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-twentynine-content">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
																<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																	<div class="semicircle-left semicircle-left-curve"></div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 30) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 31) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 32) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-header">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-template-footer">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 33) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-2 col-md-2 col-sm-2 col-2">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8 pr0 bg_col1">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 34) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />

										</div>
									</div>
								</div>
							) : (this.state.template_id === 35) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-12">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 36) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtysix">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
															<div class="triangle-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-re-points">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 37) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pl0">
															<div class="triangle-right"></div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 38) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-5 col-5" style={styletmp.top_bg_col1}>
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
															<div class="col-md-7 col-7">
																<div style={styletmp.top_bg_col1}>
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 39) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-thirtynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5" style={styletmp.top_bg_col1}>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 40) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5"></div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-twentynine-content">
															<div class="row">
																<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																	<div class="semicircle-right semicircle-right-curve"></div>
																</div>
																<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 41) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 42) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 43) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">                   
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0 pl0">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 44) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>          
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0">
															<div class="triangle-right"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 45) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}>
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>                  
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">                      
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>  
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 46) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtysix">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">           
														<div class="col-xl-4 col-md-4 col-sm-4 col-4 pr0">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-1 col-md-1 col-sm-1 col-1 pl0">
															<div class="triangle-left"></div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
													</div> 
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 47) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">           
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
															<div class="half-circle"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div> 
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 48) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0 bg_col1">                
															<div class="div-points">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
															<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">                      
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 49) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fourtynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="div-diamond"></div>                               
														<div class="div-items text-center">
															<div class="div-points">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 50) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fifty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 

													<div class="row">                                        
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-1 col-md-1 col-sm-1 col-1 pl0">
															<div class="triangle-left"></div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 51) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pt10 bg_col1">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>                  
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 52) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
	
							) : (this.state.template_id === 53) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-header">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-template-footer">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 54) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-2 col-md-2 col-sm-2 col-2">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8 pr0 bg_col1">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 55) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-12">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img> 
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 56) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftysix">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">                   
															<div class="col-xl-7 col-md-7 col-sm-7 col-7">
															<div class="div-left"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
															<div class="col-xl-7 col-md-7 col-sm-7 col-6 pl0">
															</div>                  
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 57) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-xl-5 col-md-5 col-sm-5 col-5">                      
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
															<div class="col-xl-7 col-md-7 col-sm-7 col-7 pl0">                  
																<div class="triangle-right"></div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 58) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-5 col-5">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
															<div class="col-md-7 col-7">
																<div>
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 59) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-fiftynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 60) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-sixty-content">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																	<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
																<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																	<div class="semicircle-left semicircle-left-curve"></div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>

							) : (this.state.template_id === 61) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">                  
															<div class="triangle-right"></div>
														</div>                  
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">                      
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>   
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 62) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 63) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
															<div class="row">
																<div class="col-xl-8 col-md-8 col-sm-8 col-8 pr0 bg_col1">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 64) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">                                        
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
															<div class="triangle-left"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															<div class="div-re-points">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>                                        
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 65) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-circle bg_col1">
													</div>
													<div class="div-logo">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-card-header">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 66) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtysix">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
														</div>
														<div class="col-xl-8 col-md-8 col-sm-8 col-8">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 67) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-circle bg_col1">
													</div>
													<div class="div-logo">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-card-header">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 68) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5"></div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-twentynine-content">
															<div class="row">
																<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																	<div class="semicircle-right semicircle-right-curve"></div>
																</div>
																<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 69) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-sixtynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 70) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventy">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-header">
														<img src={this.state.giftdet.gift_logo} alt="logo"></img>
													</div>
													<div class="div-template-footer">
														<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 71) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">                   
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
														<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>                  
													</div> 
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 72) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">
														</div>
														<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0 bg_col1">
															<div class="row">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 73) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-5 col-md-5 col-sm-5 col-5"></div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-twentynine-content">
															<div class="row">
																<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																	<div class="semicircle-right semicircle-right-curve"></div>
																</div>
																<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
																
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 74) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">                   
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
															<div class="half-circle"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 75) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">                                                                             
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
															<div class="half-circle"></div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 76) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventysix">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">             
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">                     
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-7 col-md-7 col-sm-7 col-7 pdlft">              
															<div class="triangle-right"></div>
														</div> 
													</div> 
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 77) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventyseven">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-7 col-md-7 col-sm-7 col-7">                  
															<div class="triangle-right"></div>
														</div>                  
														<div class="col-xl-5 col-md-5 col-sm-5 col-5">                      
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>   
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 78) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventyeight">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="row">
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 79) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-seventynine">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
												<div class="row">
													<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
														</div>
														<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 80) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eighty">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 81) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightyone">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="col-md-6 text-right">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>													
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 82) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightytwo">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">                                                            
															<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																<div class="div-left"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
															<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 83) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightythree">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="row">
															<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
															</div>
															<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																<div class="div-left"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 84) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightyfour">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">														 
														<div class="div-circle bg_col1">
														</div>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 85) ? (
								<div className="row m_top2 m0">
									<div className="col-md-12 pl0 pr02">
										<div className="div_template_parent m_bot3 m_rl15">
											<div class="div-gift-template-eightyfive">
												<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<div class="div-template-footer">
														<div class="div-circle bg_col1">
														</div>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
												</div>
												<div class="col-md-12 bb">
													<div class="div-footer-description">
														<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
													</div>
												</div>
											</div>
											<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
										</div>
									</div>
								</div>
							) : (this.state.template_id === 86) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-eightysix">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">                   
															<div class="col-xl-5 col-md-5 col-sm-5 col-5 pr0">
																<div class="triangle-right"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
															<div class="col-xl-7 col-md-7 col-sm-7 col-7">
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 87) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-eightyseven">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">
															<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															</div>          
															<div class="col-xl-6 col-md-6 col-sm-6 col-6 pr0">
																<div class="triangle-right"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 88) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-eightyeight">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">
															<div class="col-xl-5 col-md-5 col-sm-5 col-5"></div>
															<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-twentynine-content">
																<div class="row">
																	<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																		<div class="semicircle-right semicircle-right-curve"></div>
																	</div>
																	<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																		<div class="div-logo">
																			<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																		</div>
																		<div class="div-card-header">
																			<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																		</div>
																	</div>
																	
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 89) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-eightynine">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">
															<div class="col-xl-7 col-md-7 col-sm-7 col-7 div-sixty-content">
																<div class="row">
																	<div class="col-xl-8 col-md-8 col-sm-8 col-8">
																		<div class="div-logo">
																			<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																		</div>
																		<div class="div-card-header">
																			<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																		</div>
																	</div>
																	<div class="col-xl-4 col-md-4 col-sm-4 col-4 pl0">
																		<div class="semicircle-left semicircle-left-curve"></div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 90) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninety">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														
														<div class="div-circle bg_col1">
														</div>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
														
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 91) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetyone">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														
														<div class="div-circle bg_col1">
														</div>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
														
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 92) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetytwo">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">
															<div class="col-xl-7 col-md-7 col-sm-7 col-7">
															</div>
															<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0 bg_col1">
																<div class="row">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 93) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetythree">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">
															<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0 bg_col1">
																<div class="row">
																	<div class="div-logo">
																		<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																	</div>
																	<div class="div-card-header">
																		<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																	</div>
																</div>
															</div>
															<div class="col-xl-7 col-md-7 col-sm-7 col-7">
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 94) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetyfour">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="div-template-footer">
															<div class="div-circle bg_col1">
															</div>
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 95) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetyfive">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="row">                   
															<div class="col-xl-6 col-md-6 col-sm-6 col-6">
															<div class="div-left"></div>
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
															<div class="col-xl-6 col-md-6 col-sm-6 col-6 pl0">
															</div>                  
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 96) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetysix">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
													<	div class="row">                   
															<div class="col-xl-7 col-md-7 col-sm-7 col-7 pr0">
																<div class="div-logo">
																	<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
															</div>
															<div class="col-xl-5 col-md-5 col-sm-5 col-5 pl0">
																<div class="div-right"></div>
																<div class="div-card-header">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>                  
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 97) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetyseven">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="div-parent">
															<div class="div-logo bg_col1">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header bg_col1">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 98) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetyeight">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="div-parent bg_col1">
															<div class="div-logo">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
															</div>
															<div class="div-card-header">
																<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 99) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-ninetynine">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="div-template-footer">
															<div class="row">
																<div class="col-md-6">
																<img src={this.state.giftdet.gift_logo} alt="logo"></img>
																</div>
																<div class="col-md-6 text-right">
																	<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>
								) : (this.state.template_id === 100) ? (
									<div className="row m_top2 m0">
										<div className="col-md-12 pl0 pr02">
											<div className="div_template_parent m_bot3 m_rl15">
												<div class="div-gift-template-hundred">
													<div class="div-gift-template m_bot5" style={styletmp.bg_box}> 
														<div class="div-circle bg_col1">
														</div>
														<div class="div-logo">
															<img src={this.state.giftdet.gift_logo} alt="logo"></img>
														</div>
														<div class="div-card-header">
															<span style={styletmp.top_text_col}>{this.state.giftdet.name}</span>
														</div>
													</div>
													<div class="col-md-12 bb">
														<div class="div-footer-description">
															<p style={styletmp.mid_text_col}>{this.state.giftdet.short_description}</p>
														</div>
													</div>
												</div>
												<Template1 giftdet={this.state.giftdet} lang={this.state.lang} styletmp={styletmp} gift_id={this.state.gift_id} />
											</div>
										</div>
									</div>






															


							) : (
																																																<div></div>
																																															)

						}
					</div>
				) : (this.state.res_status === 202) ? (

					<div>
						<span className="curr_unavail">{this.state.lang.curr_unavail_gift}</span>
						<center><img alt="noimage" style={{width: '80%'}} src={api_url+"/public/img/empty.png"} /></center>
					
					</div>

				) : (
					<div></div>
				)}

			</div>


		);
	}
}


export default Giftpage;
